import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import authService from "../services/Auth.Service"
import  axios  from "axios"; 

export const userSingup = createAsyncThunk("user/singuo",async (formData)=>{
  const response  = axios({
    url:"/users/singup",
    data:formData,
    method:"POST",
    headers: {
      "Accept-Language": "en-US,en;q=0.8",
      "Content-Type": "application/json",
    }
  });
  return response;
});

export const login = createAsyncThunk(
  "auth/login",
  async (formData, thunkAPI) => {
    try{
      const data = await authService.login(formData);
      console.log("qqqqq", data)
      return data;
    }catch(exception){
      console.log(exception.response)
      if (!exception.response) {
        return exception;
      }
      return thunkAPI.rejectWithValue(exception?.response?.data)
    }
  }
);
  
export const logout = createAsyncThunk("auth/logout", async () => {
  await authService.logout();
  return true
});

const initialState = {
  errors:'',
  success:'',
  loading:false,
  authData:{
    isLoggedIn:false,
    user:{}
  }
}
const AuthSlice = createSlice({
  name : "auth",
  initialState,
  reducers:{
    reset:() => initialState,
    setUserData: (state, action) => {
        return {
            ...state,
            authData: action.payload
        }
    }
  },
  extraReducers: {
    [userSingup.pending] : (state) => {
      state.loading = true
      state.errors = false
      state.success = false
    },
    [userSingup.fulfilled] : (state, action) => {
      state.loading = false;
      if(!action.payload.data.success){
        state.errors = action.payload.data.error;    
      }else{
        state.success = action.payload.data.message;
      }
      //state.entities = [...state.entities, ...action.payload];;
    },
    [userSingup.rejected] : (state) => {
      state.loading = false;
    },

        
    [login.pending]: (state) => {
            
      state.authData.isLoggedIn = false;
      state.loading = true;
      //console.log("Pending")
    },
    [login.rejected]: (state, action) => {
      state.loading = false;
      state.success = false
      state.authData.isLoggedIn = false;
      state.errors = action.payload.errors.msg
      state.authData.user = null;
    },
    [login.fulfilled]: (state, action) => {
      state.loading = false;
      console.log(action)
      // if(action.payload.status === "success"){
      //   //state.navigation = action.payload.user.navigation
        
        
      // }else{
      //   console.log(action.payload)
      //   state.errors = action.payload?.user?.error?action.payload?.user?.error:action.payload
      // }
      state.authData = {
        token : action.payload.accessToken,
        user: action.payload.user
      }
      //state.authData.isLoggedIn = true
      state.success = true
      //state.authData.user = null;
    },

    [logout.fulfilled]: (state) => {
      state.authData.isLoggedIn = false
      state.authData.user = {}
    }

  }
})


export const { reset, setUserData } = AuthSlice.actions;

export default AuthSlice.reducer